import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { CustomThemeToken } from '@/theme/theme.utils';

/* Temporary wrapper for 90% scaling. Remove when whole-app scaling is implemented. */
export const ScaleWrapper = styled.div<{ theme: { token: CustomThemeToken } }>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${({ theme: { token } }) => token.colorBgElevatedDarker};
`;

export const PageContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  height: 111.11%; /* Compensate for 0.9 scale (100% / 0.9 = 111.11%) */
  width: 111.11%; /* Compensate for 0.9 scale (100% / 0.9 = 111.11%) */
  background-color: transparent;
  overflow-x: hidden;
  overflow-y: visible;
  min-width: 0; /* Allow flex children to shrink below their content size */
  position: relative;
  z-index: 1;
  /* Temporary: Scale to 90% to match Figma design. Remove when whole-app scaling is implemented. */
  transform: scale(0.9);
  transform-origin: top left;
`;

export const BackgroundIcon = styled.div<{ theme: { token: CustomThemeToken } }>`
  position: fixed;
  top: -340px;
  left: 0;
  width: 100%;

  height: auto;
  z-index: 0;
  pointer-events: none;
  overflow: visible;
  will-change: transform;
  background: radial-gradient(
      ellipse 895.66px 622.8px at 20% 30%,
      rgba(34, 187, 232, 0.2) 0%,
      rgba(34, 187, 232, 0.1) 30%,
      rgba(34, 187, 232, 0.05) 50%,
      transparent 70%,
      ${({ theme: { token } }) => token.colorBgElevatedDarker} 85%,
      ${({ theme: { token } }) => token.colorBgElevatedDarker} 100%
    ),
    ${({ theme: { token } }) => token.colorBgElevatedDarker};
  background-size: 100% auto;
  background-repeat: no-repeat;

  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.02;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0.8) 75%,
      rgba(0, 0, 0, 0.4) 85%,
      rgba(0, 0, 0, 0) 100%
    );
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0.8) 75%,
      rgba(0, 0, 0, 0.4) 85%,
      rgba(0, 0, 0, 0) 100%
    );
  }
`;

export const TopBar = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  min-height: 36px;
  padding-top: ${({ theme: { token } }) => token.paddingSM}px;
  padding-bottom: ${({ theme: { token } }) => token.paddingSM}px;
  width: 100%;
  border-bottom: 1px solid ${({ theme: { token } }) => `${token.colorBorderSecondary}44`};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TopBarLeft = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  width: 340px;
  min-width: 340px;
  max-width: 340px;
  margin-left: ${({ theme: { token } }) => token.marginLG}px;
  margin-right: 0;
  padding: 0;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 90%;
    min-width: 90%;
    max-width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const BackButtonContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: absolute;
  top: ${({ theme: { token } }) => token.marginLG}px;
  left: ${({ theme: { token } }) => token.marginLG}px;
  z-index: 1000;
`;

export const BackButton = styled.button<{ theme: { token: GlobalToken } }>`
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  border: 1px solid ${({ theme: { token } }) => token.colorBorder};
  padding: ${({ theme: { token } }) => token.paddingXS}px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  transition: all 0.3s ease;
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  flex-shrink: 0;
  width: 32px;
  height: 32px;

  &:hover {
    border-color: ${({ theme: { token } }) => token.colorPrimary};
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  &:active {
    border-color: ${({ theme: { token } }) => token.colorPrimary};
  }
`;

export const StationPickerWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  width: 340px;
  min-width: 340px;
  max-width: 340px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }

  .eco-select-station {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
    margin: 0 !important;
    padding: 0 !important;

    .ant-select {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    .ant-select-selector {
      width: 100% !important;
      box-sizing: border-box;
    }
  }
`;

export const TopBarRight = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 32px;
  padding-left: ${({ theme: { token } }) => token.paddingLG}px;
  padding-right: ${({ theme: { token } }) => token.paddingLG}px;
  margin-left: ${({ theme: { token } }) => token.marginSM}px;
  @media (max-width: 768px) {
    width: 90%;
    min-width: 90%;
    max-width: 90%;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    margin-left: 5%;
    margin-right: 5%;
  }

  /* Style StationStages to match select height */
  > div {
    height: 32px;
    min-height: 32px;
    margin: 0 !important;
    width: 100%;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

    > div {
      height: 32px !important;
      min-height: 32px !important;
      padding: 0 ${({ theme: { token } }) => token.paddingSM}px !important;
      margin: 0 !important;
      border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    }
  }
`;

export const MainContent = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
  min-width: 0;
  position: relative;
  z-index: 1;
`;

interface InsightsPanelProps {
  $isCollapsed: boolean;
  $isMobile: boolean;
  theme: { token: CustomThemeToken };
}

const insightsPanelDesktopStyling = `
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
`;

const insightsPanelMobileStyling = `
  height: calc(100vh - 46px);
  position: fixed;
  z-index: 3;
  top: 46px;
  left: 0px;
`;

export const InsightsPanel = styled.div<InsightsPanelProps>`
  display: flex;
  ${({ $isMobile }) => ($isMobile ? insightsPanelMobileStyling : insightsPanelDesktopStyling)}
  flex-shrink: 0;
  flex-grow: 0;
  width: ${({ $isCollapsed }) => ($isCollapsed ? `0px` : 'auto')} !important;
  min-width: ${({ $isCollapsed }) => ($isCollapsed ? `0px` : '450px')} !important;
  max-width: ${({ $isCollapsed }) => ($isCollapsed ? `0px` : '450px')} !important;
  padding: 0;
  box-sizing: border-box;
  background-color: ${({ theme: { token } }) => token.colorBgLayout};
  margin-right: 0;
  transition: width 0.15s ease-out;
  overflow: visible;
  z-index: ${({ $isCollapsed, $isMobile }) => ($isMobile ? '1000' : $isCollapsed ? '1000' : '1')};
  position: ${({ $isMobile }) => ($isMobile ? 'fixed' : 'relative')};
  height: 100%;

  .container {
    display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'flex')};
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    background-color: ${({ theme: { token } }) => token.colorBgPanelContainer};
  }
`;

export const InsightsPanelHeader = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.paddingLG}px
    ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingLG}px;
  background-color: transparent;
`;

export const InsightsHeaderTop = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
`;

export const CloseIconButton = styled.button<{ theme: { token: GlobalToken } }>`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const InsightsHeaderTitle = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  font-size: ${({ theme: { token } }) => token.fontSizeHeading5}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};

  span:first-child {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  span:last-child {
    font-weight: 400;
  }
`;

export const InsightsHeaderFilters = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginLG}px;
`;

export const StationPickerContainer = styled.div<{ theme: { token: GlobalToken } }>`
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
`;

export const InsightsMessage = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  padding: ${({ theme: { token } }) => token.padding}px;
  background-color: transparent;
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;

  svg {
    flex-shrink: 0;
  }

  .message-text {
    width: 100%;
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    text-align: left;
  }
`;

export const InsightsTitle = styled.h3<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  margin: 0 0 ${({ theme: { token } }) => token.marginLG}px ${({ theme: { token } }) => token.marginSM}px;
`;

export const InsightsList = styled.div<{ theme: { token: GlobalToken } }>`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.paddingLG}px
    ${({ theme: { token } }) => token.paddingLG}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  will-change: scroll-position;
  transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
  scroll-behavior: auto;

  &::-webkit-scrollbar {
    width: ${({ theme: { token } }) => token.marginXXS + token.paddingXXS}px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme: { token } }) => token.colorTextQuaternary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme: { token } }) => token.colorTextTertiary};
  }
`;

export const ChatPanel = styled.div<{ $isEmpty?: boolean; $isCollapsed?: boolean; theme: { token: GlobalToken } }>`
  flex: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: transparent;
  margin-right: 0; /* Panel overlays on top, no space reservation */
  ${({ $isEmpty }) =>
    $isEmpty
      ? `
        justify-content: center;
        align-items: center;
      `
      : ''}
`;

export const InsightPanelWrapper = styled.div<{
  $isCollapsed: boolean;
  $isMobile?: boolean;
  theme: { token: GlobalToken };
}>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  pointer-events: none;
  z-index: ${({ $isMobile }) => ($isMobile ? '1000' : '100')}; /* Higher z-index to overlay on conversation */
  padding-right: 0;
  overflow: visible;

  > * {
    pointer-events: auto;
  }

  .btn-collapse-container {
    position: absolute;
    top: ${({ theme: { token } }) => token.marginLG}px;
    right: ${({ theme: { token } }) => token.marginLG}px;
    z-index: 1000;
    pointer-events: auto;
    display: ${({ $isCollapsed }) => ($isCollapsed ? 'block' : 'none')};
  }
`;

export const TabsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  margin-bottom: ${({ theme: { token } }) => token.marginMD}px;

  .ant-tabs-nav {
    margin-bottom: 0;

    &::before {
      display: none;
    }
  }

  .ant-tabs-nav-wrap {
    justify-content: flex-start !important;
  }

  .ant-tabs-nav-list {
    justify-content: flex-start !important;
    width: 100%;
  }

  .ant-tabs-tab {
    text-align: left;
    justify-content: flex-start;
  }

  .ant-tabs-tab-btn {
    text-align: left;
  }
`;

export const InsightCardSkeleton = styled.div<{ theme: { token: GlobalToken } }>`
  background-color: transparent;
  border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  padding: ${({ theme: { token } }) => token.padding}px;
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  width: 100%;
  max-width: 100%;
`;

export const EmptyState = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme: { token } }) => token.paddingXL}px ${({ theme: { token } }) => token.padding}px;
  text-align: center;

  .empty-message {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    margin: 0;
  }
`;
